import { useSelector } from 'react-redux'
import { RootState } from '../redux'
import { Lift } from '../types'

export default function useLift(): Lift | undefined {
  return useSelector((state: RootState) => state.lifts.lift)
}
